function rentMeCopyForm(item, formatDate) {
  const format = typeof formatDate === 'function' ? formatDate : (value) => value || '';
  return {
    propertyId: item.propertyId,
    item_type: item.item_type,
    description: item.description,
    serial_no: '',
    model_no: item.model_no || '',
    monthly_rate: parseFloat(item.monthly_rate),
    min_months: item.min_months,
    starts_on: format(item.starts_on),
    ends_on: format(item.ends_on),
    purchasable: Boolean(item.purchasable),
    purchase_amt: item.purchase_amt ? parseFloat(item.purchase_amt) : null,
  };
}

module.exports = {
  rentMeCopyForm,
};
